webpackJsonp([1],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(101);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(79)("09efa215", content, true, {});

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)(true);
// imports


// module
exports.push([module.i, ".icon[data-v-3fd853bf]{width:24px;margin-bottom:4px}.v-list:not(.no-border)>[data-v-3fd853bf]{border-bottom:1px solid #e1e1e1}@media (min-width:900px){.tabs[data-v-3fd853bf]{-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;width:100%}.tabs .tab[data-v-3fd853bf],.tabs[data-v-3fd853bf]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal}.tabs .tab[data-v-3fd853bf]{width:33%;margin:0 10px;-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}.tab .image[data-v-3fd853bf]{max-height:110px}.tab .v-card__text[data-v-3fd853bf]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.tab .v-card__text .v-list[data-v-3fd853bf],.tab .v-card__text[data-v-3fd853bf]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.v-btn--bottom[data-v-3fd853bf]:not(.v-btn--absolute){bottom:35px}@media (max-width:900px){.tabs .tab[data-v-3fd853bf]{margin:0 10px;margin-bottom:30px}}", "", {"version":3,"sources":["/vue-ui/src/views/Setup.vue"],"names":[],"mappings":"AACA,uBACE,WAAY,AACZ,iBAAmB,CACpB,AACD,0CACE,+BAAiC,CAClC,AACD,yBACA,uBAII,8BAA+B,AAE3B,uBAAwB,AACpB,mBAAoB,AAC5B,UAAY,CACf,AACD,mDATI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAEd,4BAA8B,CAkBjC,AAbD,4BACI,UAAW,AACX,cAAe,AAOf,4BAA6B,AAEzB,0BAA2B,AACvB,qBAAuB,CAClC,AACD,6BACI,gBAAkB,CACrB,AACD,oCAII,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,gFAXI,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAaxB,CACA,AACD,sDACE,WAAa,CACd,AACD,yBACA,4BACI,cAAe,AACf,kBAAoB,CACvB,CACA","file":"Setup.vue","sourcesContent":["\n.icon[data-v-3fd853bf] {\n  width: 24px;\n  margin-bottom: 4px;\n}\n.v-list:not(.no-border) > *[data-v-3fd853bf] {\n  border-bottom: 1px solid #e1e1e1;\n}\n@media (min-width: 900px) {\n.tabs[data-v-3fd853bf] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    width: 100%;\n}\n.tabs .tab[data-v-3fd853bf] {\n    width: 33%;\n    margin: 0 10px;\n\n    display: -webkit-box;\n\n    display: -ms-flexbox;\n\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.tab .image[data-v-3fd853bf] {\n    max-height: 110px;\n}\n.tab .v-card__text[data-v-3fd853bf] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.tab .v-card__text .v-list[data-v-3fd853bf] {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}\n}\n.v-btn--bottom[data-v-3fd853bf]:not(.v-btn--absolute) {\n  bottom: 35px;\n}\n@media (max-width: 900px) {\n.tabs .tab[data-v-3fd853bf] {\n    margin: 0 10px;\n    margin-bottom: 30px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetupItemCell_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4452bd64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetupItemCell_vue__ = __webpack_require__(105);
function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4452bd64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SetupItemCell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4452bd64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SetupItemCell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(104);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(79)("d49e8662", content, true, {});

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)(true);
// imports


// module
exports.push([module.i, ".row[data-v-4452bd64]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.row .name-cell[data-v-4452bd64]{width:66%}.row .value-cell[data-v-4452bd64]{width:33%;text-align:right}.row.edit .name-cell[data-v-4452bd64],.row.edit .value-cell[data-v-4452bd64]{width:50%}.row.edit .name-cell[data-v-4452bd64]{margin-right:10px}", "", {"version":3,"sources":["/vue-ui/src/components/SetupItemCell.vue"],"names":[],"mappings":"AACA,sBACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,iCACE,SAAW,CACZ,AACD,kCACE,UAAW,AACX,gBAAkB,CACnB,AACD,6EAEE,SAAW,CACZ,AACD,sCACE,iBAAmB,CACpB","file":"SetupItemCell.vue","sourcesContent":["\n.row[data-v-4452bd64] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.row .name-cell[data-v-4452bd64] {\n  width: 66%;\n}\n.row .value-cell[data-v-4452bd64] {\n  width: 33%;\n  text-align: right;\n}\n.row.edit .name-cell[data-v-4452bd64],\n.row.edit .value-cell[data-v-4452bd64] {\n  width: 50%;\n}\n.row.edit .name-cell[data-v-4452bd64] {\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.edit)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"name-cell"},[_vm._v(_vm._s(_vm.setupItem.name))]),_vm._v(" "),_c('div',{staticClass:"value-cell"},[_vm._v(_vm._s(_vm.setupItem.value))])]):_c('div',{staticClass:"row edit"},[_c('v-combobox',{staticClass:"name-cell",attrs:{"placeholder":_vm.$vuetify.t('$vuetify.setup.setupitem.selecttype'),"items":_vm.options,"persistent-hint":""},model:{value:(_vm.setupItem.name),callback:function ($$v) {_vm.$set(_vm.setupItem, "name", $$v)},expression:"setupItem.name"}}),_vm._v(" "),_c('v-text-field',{staticClass:"value-cell",attrs:{"placeholder":"10 psi"},model:{value:(_vm.setupItem.value),callback:function ($$v) {_vm.$set(_vm.setupItem, "value", $$v)},expression:"setupItem.value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.edit)?_c('v-text-field',{attrs:{"outline":"","placeholder":_vm.$vuetify.t('$vuetify.setup.setuptitle'),"label":_vm.$vuetify.t('$vuetify.setup.setuptitle'),"rules":_vm.inputRules},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.save($event)}},model:{value:(_vm.setup.name),callback:function ($$v) {_vm.$set(_vm.setup, "name", $$v)},expression:"setup.name"}}):_vm._e(),_vm._v(" "),(!_vm.edit)?_c('v-btn',{attrs:{"color":"primary","dark":"","small":_vm.isMobile,"mb-3":"","fixed":"","bottom":"","right":"","fab":"","title":_vm.$vuetify.t('$vuetify.edit_setup')},on:{"click":function($event){_vm.edit=true}}},[_c('v-icon',[_vm._v("edit")])],1):_c('v-btn',{attrs:{"color":"primary","dark":"","small":_vm.isMobile,"mb-3":"","fixed":"","bottom":"","right":"","fab":"","title":_vm.$vuetify.t('$vuetify.save')},on:{"click":_vm.save}},[_c('v-icon',[_vm._v("save")])],1),_vm._v(" "),(_vm.setup)?_c('div',{staticClass:"tabs"},[_c('v-card',{staticClass:"tab"},[_c('v-img',{staticClass:"image",attrs:{"src":"/static/img/setup_fork.png"}}),_vm._v(" "),_c('v-card-title',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.fork'))}},[_vm._v("Fork")]),_vm._v(" "),_c('v-card-text',[_c('v-list',{class:_vm.edit ? 'no-border' : '',attrs:{"two-line":_vm.edit}},_vm._l((_vm.setup.forkSetups),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('setup-cell',{attrs:{"setup-item":item,"edit":_vm.edit,"type":"fork"}})],1)],1)}),1)],1),_vm._v(" "),(_vm.edit)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.addEmpty('fork')}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"tab"},[_c('v-img',{staticClass:"image",attrs:{"src":"/static/img/setup_shock.png"}}),_vm._v(" "),_c('v-card-title',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.shock'))}},[_vm._v("Shock")]),_vm._v(" "),_c('v-card-text',[_c('v-list',{class:_vm.edit ? 'no-border' : '',attrs:{"two-line":_vm.edit}},_vm._l((_vm.setup.shockSetups),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('setup-cell',{attrs:{"setup-item":item,"edit":_vm.edit,"type":"shock"}})],1)],1)}),1)],1),_vm._v(" "),(_vm.edit)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.addEmpty('shock')}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"tab"},[_c('v-img',{staticClass:"image",attrs:{"src":"/static/img/setup_misc.png"}}),_vm._v(" "),_c('v-card-title',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.misc'))}},[_vm._v("Misc")]),_vm._v(" "),_c('v-card-text',[_c('v-list',{class:_vm.edit ? 'no-border' : '',attrs:{"two-line":_vm.edit}},_vm._l((_vm.setup.miscSetups),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('setup-cell',{attrs:{"setup-item":item,"edit":_vm.edit,"type":"misc"}})],1)],1)}),1),_vm._v(" "),(_vm.edit)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.addEmpty('misc')}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDeleteDialog),callback:function ($$v) {_vm.showDeleteDialog=$$v},expression:"showDeleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.delete_title'))+" Setup")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.delete_start'))+" Setup \""+_vm._s(_vm.dialogContent)+"\" "+_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.delete_end'))+"\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","flat":"flat"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.cancel'))},on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","flat":"flat"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.ok'))},on:{"click":_vm.clickDeleteDialogOK}},[_vm._v("\n          OK\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__ = __webpack_require__(89);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd853bf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__ = __webpack_require__(106);
function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fd853bf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fd853bf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SetupItemCell__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_StringMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__(5);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_StringMixin__["a" /* default */]],
  name: 'Setup',
  components: { 'setup-cell': __WEBPACK_IMPORTED_MODULE_2__components_SetupItemCell__["a" /* default */] },
  data: function data() {
    var _this = this;

    return {
      edit: false,
      selectedSetup: 'fork',
      isMobile: false,
      setup: null,
      showDeleteDialog: false,
      dialogContent: null,
      inputRules: [function (v) {
        return !!v || _this.$vuetify.t('$vuetify.errormsg.required');
      }, function (v) {
        return v.length >= 3 || _this.$vuetify.t('$vuetify.errormsg.minlength');
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])([])),
  watch: {
    '$route': function $route(to, from) {
      // workaround for copy -> edit
      if (this.$store.state.lastSetup && this.$store.state.lastSetup.id != to.params.setupId) {
        this.edit = false;
      }
      this.loadSetup();
    }
  },
  mounted: function mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    this.loadSetup();
    __WEBPACK_IMPORTED_MODULE_5__main__["eventBus"].$emit('menu-change', {
      menu: [{ id: 'copy', title: this.$vuetify.t('$vuetify.duplicate_setup'), icon: 'file_copy' }, { id: 'delete', title: this.$vuetify.t('$vuetify.delete_setup'), icon: 'delete' }]
    });
    __WEBPACK_IMPORTED_MODULE_5__main__["eventBus"].$on('menu-selected', this.menuSelected.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
    __WEBPACK_IMPORTED_MODULE_5__main__["eventBus"].$emit('menu-change', { menu: [] });
    __WEBPACK_IMPORTED_MODULE_5__main__["eventBus"].$off('menu-selected', this.menuSelected);
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['updateSetup', 'copySetup', 'deleteSetup']), {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < 900;
    },
    menuSelected: function menuSelected(e) {
      switch (e) {
        case 'copy':
          {
            if (this.setup) {
              console.log('copy start');
              this.copySetup({ setup: this.setup });
              this.$router.push('' + this.$store.state.lastSetup.id);
              this.edit = true;
              console.log('copy end');
            }
            break;
          }
        case 'delete':
          {
            this.dialogContent = this.setup.name;
            this.showDeleteDialog = true;
            break;
          }
      }
    },
    loadSetup: function loadSetup() {
      var setup = this.$store.getters.setup(this.$route.params.setupId);
      if (setup) {
        this.setup = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(setup));

        __WEBPACK_IMPORTED_MODULE_5__main__["eventBus"].$emit('title-change', setup.name);
      }
    },
    addEmpty: function addEmpty(type) {
      switch (type) {
        case 'fork':
          {
            this.setup.forkSetups.push({});
            break;
          }
        case 'shock':
          {
            this.setup.shockSetups.push({});
            break;
          }
        default:
          {
            this.setup.miscSetups.push({});
            break;
          }
      }
    },
    save: function save() {
      for (var i = 0; i != this.setup.forkSetups.length;) {
        if (this.isNullOrEmpty(this.setup.forkSetups[i].name) || this.isNullOrEmpty(this.setup.forkSetups[i].value)) {
          this.setup.forkSetups.splice(i, 1);
        } else {
          i++;
        }
      }
      for (var i = 0; i != this.setup.shockSetups.length;) {
        if (this.isNullOrEmpty(this.setup.shockSetups[i].name) || this.isNullOrEmpty(this.setup.shockSetups[i].value)) {
          this.setup.shockSetups.splice(i, 1);
        } else {
          i++;
        }
      }
      for (var i = 0; i != this.setup.miscSetups.length;) {
        if (this.isNullOrEmpty(this.setup.miscSetups[i].name) || this.isNullOrEmpty(this.setup.miscSetups[i].value)) {
          this.setup.miscSetups.splice(i, 1);
        } else {
          i++;
        }
      }
      this.updateSetup({ setup: this.setup });
      this.edit = false;
    },
    clickDeleteDialogOK: function clickDeleteDialogOK() {
      this.deleteSetup({ setupId: this.setup.id });
      this.showDeleteDialog = false;
      this.$router.push('/');
    }
  })
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['setupItem', 'edit', 'type'],
  name: 'SetupItemCell',
  data: function data() {
    return {};
  },

  computed: {
    nameModel: {
      get: function get() {
        return this.setupItemName != null ? this.setupItemName : this.setupItem != null ? this.setupItem.name : '';
      },
      set: function set(value) {
        this.setupItemName = value;
      }
    },
    valueModel: {
      get: function get() {
        return this.setupItemValue != null ? this.setupItemValue : this.setupItem != null ? this.setupItem.value : '';
      },
      set: function set(value) {
        this.setupItemValue = value;
      }
    },
    options: function options() {
      switch (this.type) {
        case 'fork':
          {
            return ['Compression', 'Lowspeed Compression', 'Highspeed Compression', 'Rebound', 'Lowspeed Rebound', 'Highspeed Rebound', this.$vuetify.t('$vuetify.setuptype.pressure'), this.$vuetify.t('$vuetify.setuptype.spring'), 'OTT', 'Bottom out'];
          }
        case 'shock':
          {
            return ['Compression', 'Lowspeed Compression', 'Highspeed Compression', 'Rebound', 'Lowspeed Rebound', 'Highspeed Rebound', this.$vuetify.t('$vuetify.setuptype.pressure'), this.$vuetify.t('$vuetify.setuptype.spring'), 'Bottom out'];
          }
        default:
          {
            return [this.$vuetify.t('$vuetify.setuptype.tire_front'), this.$vuetify.t('$vuetify.setuptype.tire_rear'), this.$vuetify.t('$vuetify.setuptype.pressure_front'), this.$vuetify.t('$vuetify.setuptype.pressure_rear'), this.$vuetify.t('$vuetify.setuptype.chainring')];
          }
      }
    }
  },
  methods: {}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.42df239c31f94f332b8c.js